import React, {Component} from 'react';
import { ReactComponent as InstagramLogo } from './assets/instagram.svg';
import { ReactComponent as FacebookLogo } from './assets/facebook.svg';
import { ReactComponent as TwitterLogo } from './assets/twitter.svg';
import { ReactComponent as WhatsappLogo } from './assets/whatsapp.svg';

class Share extends Component {

  render() {
    return (
      <div>
        <div className="columns is-fullwidth">
          <div className="column">
            <a
              target="_blank"
              className="button is-fullwidth gp-share-twitter"
              href="https://twitter.com/intent/tweet?text=%2340ansCaSuffit%20il%20est%20temps%20de%20d%C3%A9brancher%20les%20centrales%20!%20On%20a%20toutes%20et%20tous%20une%20raison%20l%C3%A9gitime%20de%20dire%20non%20au%20nucl%C3%A9aire.%20Je%20soutiens%20celles%20et%20ceux%20qui%20sont%20poursuivi%C2%B7es%20pour%20avoir%20lanc%C3%A9%20l%E2%80%99alerte%20%C3%A0%20Tricastin%20et%20ailleurs%20www.greenpeace.fr%2Fcarte-opposition-nucleaire"
              rel="noopener noreferrer"
            >
              <span className="icon">
                <TwitterLogo/>
              </span>
              <span>Twitter</span>
            </a>
          </div>
          <div className="column">
            <a
              target="_blank"
              className="button is-fullwidth gp-share-facebook"
              href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.greenpeace.fr%2Fcarte-opposition-nucleaire%2F"
              rel="noopener noreferrer"
            >
              <span className="icon">
                <FacebookLogo/>
              </span>
              <span>Facebook</span>
            </a>
          </div>
        </div>
        <div className="columns is-fullwidth">
          <div className="column">
            <a
              target="_blank"
              className="button is-fullwidth gp-share-instagram"
              href="https://www.instagram.com/greenpeace_france/"
              rel="noopener noreferrer"
            >
              <span className="icon">
                <InstagramLogo/>
              </span>
              <span>Instagram</span>
            </a>
          </div>
          <div className="column">
            <a
              target="_blank"
              className="button is-fullwidth gp-share-whatsapp"
              href="https://api.whatsapp.com/send?text=Bonjour%2C%20je%20viens%20de%20montrer%20mon%20opposition%20au%20nucl%C3%A9aire%20sur%20une%20carte%20cr%C3%A9%C3%A9e%20par%20Greenpeace%20France%2C%20en%20soutien%20aux%20activistes%20qui%20seront%20jug%C3%A9%C2%B7es%20prochainement%20pour%20avoir%20d%C3%A9nonc%C3%A9%20le%20mauvais%20%C3%A9tat%20de%20la%20centrale%20nucl%C3%A9aire%20du%20Tricastin.%20On%20a%20toutes%20et%20tous%20des%20raisons%20l%C3%A9gitimes%20de%20dire%20non%20au%20nucl%C3%A9aire%20%3A%20%C3%A0%2040%20ans%20il%20est%20temps%20de%20d%C3%A9brancher%20les%20centrales%20!%20www.greenpeace.fr%2Fcarte-opposition-nucleaire"
              rel="noopener noreferrer"
            >
              <span className="icon">
                <WhatsappLogo/>
              </span>
              <span>Whatsapp</span>
            </a>
          </div>
        </div>
      </div>
    )
  }
}

export default Share;
